import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '@/lib/utils';
export function Card({ className, ...props }) {
    return (_jsx("div", { ...props, className: cn('rounded-xl border border-border bg-card text-card-foreground shadow-sm', className) }));
}
export function CardHeader({ className, ...props }) {
    return (_jsx("div", { ...props, className: cn('flex flex-col gap-1 px-5 py-4 border-b border-border', className) }));
}
export function CardTitle({ className, ...props }) {
    return _jsx("h3", { ...props, className: cn('text-base font-semibold leading-tight', className) });
}
export function CardDescription({ className, ...props }) {
    return _jsx("p", { ...props, className: cn('text-sm text-muted-foreground', className) });
}
export function CardContent({ className, ...props }) {
    return _jsx("div", { ...props, className: cn('p-5', className) });
}
export function CardFooter({ className, ...props }) {
    return (_jsx("div", { ...props, className: cn('flex items-center gap-2 px-5 py-3 border-t border-border', className) }));
}
export function StatCard({ label, value, delta, trend, icon, hint, className }) {
    const trendColor = trend === 'up' ? 'text-emerald-600' :
        trend === 'down' ? 'text-red-600' :
            'text-muted-foreground';
    return (_jsx(Card, { className: cn('p-5', className), children: _jsxs("div", { className: "flex items-start justify-between gap-3", children: [_jsxs("div", { className: "min-w-0 flex-1", children: [_jsx("p", { className: "text-xs font-medium uppercase tracking-wider text-muted-foreground", children: label }), _jsx("p", { className: "mt-1 text-2xl font-bold tracking-tight", children: value }), (delta || hint) && (_jsx("p", { className: cn('mt-1 text-xs', delta ? trendColor : 'text-muted-foreground'), children: delta ?? hint }))] }), icon && (_jsx("div", { className: "rounded-lg bg-primary/10 p-2 text-primary", children: icon }))] }) }));
}
